module.exports = __webpack_public_path__ + "static/img/kbz-905-385-85bb.dddb0c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/kbz-905-385-85bb.jpg
// module id = xnXl
// module chunks = 0